import { createI18n } from 'vue-i18n'

// Get saved locale from localStorage, default to 'en'
const savedLocale = typeof window !== 'undefined' 
  ? localStorage.getItem('locale') || 'en' 
  : 'en'

// Import JSON files normally
import enMessages from '../locales/en.json'
import idMessages from '../locales/id.json'

// Build messages object  
const messages: Record<string, Record<string, any>> = {
  en: enMessages,
  id: idMessages
}


const i18n = createI18n({
  locale: savedLocale, // Set default locale
  fallbackLocale: 'en', // Set fallback locale  
  legacy: false, // Use Composition API mode (works better with ESM bundle)
  globalInjection: true, // Enable global $t
  messages, // Menggunakan messages dari direct imports
  missingWarn: true, // Show warnings for missing translations in dev
  fallbackWarn: true, // Show warnings when falling back to fallback locale
})


export default i18n
